<template>
  <div>
    <StudentTableView
      v-if="currentView === 'table'"
      :user-role="userRole"
      :table-config="tableConfig"
      :create-config="createConfig"
      :reload-table="reloadTable"
      @student-selected="handleStudentSelection"
      @reload-requested="handleReloadRequest"
    />

    <StudentDetailView
      v-if="currentView === 'detail'"
      :student="selectedStudent"
      :url="tableConfig.get"
      @changeVista="handleViewChange"
    />
  </div>
</template>

<script>
import StudentTableView from './components/StudentTableView.vue'
import StudentDetailView from './ShowStudent.vue'

export default {
  name: 'TabStudents',
  
  components: {
    StudentTableView,
    StudentDetailView
  },

  props: {
    // API URLs
    get: { type: String, required: true },
    download: { type: String, required: true },
    routexuser: { type: String, required: true },
    userxroutes: { type: String, required: true },
    url: { type: String, required: true },
    
    // User & Role
    token: { type: String, required: true },
    userrol: { type: String, required: true }, // 'SU' | 'admin'
    rol: { type: Array, default: () => [] },
    
    // Table config
    headertab: { type: Array, default: () => [] },
    routes: { type: Array, default: () => [] },
    
    // Admin specific
    roladmin: { type: Array, default: () => [] },
    getadmin: { type: String, default: '' },
    empresas: { type: Array, default: () => [] },
    
    // Search URLs
    searcharea: { type: String, default: '' },
    searchnivel: { type: String, default: '' },
    urlvalidateemail: { type: String, default: '' },
    listroutes: { type: String, default: '' }
  },

  data() {
    return {
      currentView: 'table', // 'table' | 'detail'
      selectedStudent: {},
      reloadTable: false
    }
  },

  computed: {
    userRole() {
      return this.userrol
    },

    isAdminOrSU() {
      return ['admin', 'SU'].includes(this.userRole)
    },

    tableConfig() {
      return {
        token: this.token,
        rol: this.rol,
        get: this.get,
        routes: this.routes,
        routexuser: this.routexuser,
        userxroutes: this.userxroutes,
        headertab: this.headertab,
        download: this.download
      }
    },

    createConfig() {
      return {
        token: this.token,
        rol: this.roladmin,
        get: this.getadmin,
        empresas: this.empresas,
        searcharea: this.searcharea,
        urlvalidateemail: this.urlvalidateemail,
        searchnivel: this.searchnivel,
        listroutes: this.listroutes,
        urlmassive: this.url
      }
    }
  },

  methods: {
    handleViewChange(newView) {
      this.currentView = newView === 'tabla' ? 'table' : newView
    },

    handleStudentSelection(student) {
      this.selectedStudent = student
      this.currentView = 'detail'
    },

    handleReloadRequest(shouldReload) {
      this.reloadTable = shouldReload
    }
  }
}
</script>